// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 5878) return "static/chunks/5878-bbcf4f3335123245.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "57c32c6fc8f23cb7" + ".js";
};